import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/profile" element={<RedirectToProfile />} />
          <Route path="/admin/*" element={<RedirectToStatic />} />
          <Route path="/entry/*" element={<RedirectToStatic />} />
          <Route path="/establish-identity/*" element={<RedirectToStatic />} />
          <Route path="/welcome/*" element={<RedirectToStatic />} />
          <Route path="/landing/*" element={<RedirectToStatic />} />
          <Route path="/dashboard/*" element={<RedirectToStatic />} />
          <Route path="/martian/*" element={<RedirectToStatic />} />
          <Route path="*" element={<RedirectSmartRoot />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const RedirectToProfile = () => {
  const params = new URLSearchParams(window.location.search);
  window.location.href = `/profile.html?${params.toString()}`;
  return null;
};

const RedirectToStatic = () => {
  const path = window.location.pathname;
  const endsWithSlash = path.endsWith('/');
  const target = endsWithSlash ? path + 'index.html' : path + '/index.html';
  window.location.href = target + window.location.search + window.location.hash;
  return null;
};

const RedirectSmartRoot = () => {
  const token = localStorage.getItem('marsspace_token');
  if (token) {
    window.location.href = '/dashboard/';
  } else {
    window.location.href = '/landing/';
  }
  return null;
};

export default App;
